import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ResponsiveBar } from "@nivo/bar";
import { format } from "date-fns";

import { indicatorsMap } from "../dataSet/dataSet";
import Paperplane from "../../../Loading/Paperplane/Paperplane";

import * as APIDashboard from "../../../../services/nps/functions";

// import { ReactComponent as HamburgerIcon } from "../../../build/images/icons/hamburger.svg";
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

import "./ageGroup.css";

export default function AgeGroup() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const [activeButton, setActiveButton] = useState("promoter");
  const [dataGeneral, setDataGeneral] = useState([]);
  const [promoter, setPromoter] = useState([]);
  const [neutral, setNeutral] = useState([]);
  const [detractor, setDetractor] = useState([]);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    if (button === "promoter") {
      setDataGeneral(promoter);
    } else if (button === "neutral") {
      setDataGeneral(neutral);
    } else {
      setDataGeneral(detractor);
    }
  };

  async function getIndicatorsAgeRange() {
    setLoading(true);
    const response = await APIDashboard.indicatorsAgeRange(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response.status === 200) {
      const data = response.data;
      let promoterData = [];
      let neutralData = [];
      let detractorData = [];

      data.forEach((datum) => {
        let formatted = {
          ageGroup: datum.idade,
        };

        if (datum.gender_client === "M") {
          formatted.male = Number(datum.qtde);
        } else {
          formatted.female = Number(datum.qtde);
        }

        if (datum.nota === "Promotor") {
          promoterData.push(formatted);
        } else if (datum.nota === "Neutro") {
          neutralData.push(formatted);
        } else {
          detractorData.push(formatted);
        }
      });

      promoterData = formatarArray(promoterData);
      neutralData = formatarArray(neutralData);
      detractorData = formatarArray(detractorData);

      setPromoter(promoterData);
      setNeutral(neutralData);
      setDetractor(detractorData);

      if (activeButton === "promoter") {
        setDataGeneral(promoterData);
      } else if (activeButton === "neutral") {
        setDataGeneral(neutralData);
      } else {
        setDataGeneral(detractorData);
      }
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
    }
    setLoading(false);
  }

  function formatarArray(array) {
    const result = [];

    array.forEach((obj) => {
      const existingObj = result.find((item) => item.ageGroup === obj.ageGroup);

      if (existingObj) {
        if ("female" in obj) {
          existingObj.female = obj.female;
        }
        if ("male" in obj) {
          existingObj.male = obj.male;
        }
      } else {
        const newObj = { ageGroup: obj.ageGroup, female: 0, male: 0 };
        if ("female" in obj) {
          newObj.female = obj.female;
        }
        if ("male" in obj) {
          newObj.male = obj.male;
        }
        result.push(newObj);
      }
    });

    return result;
  }

  const handleColors = (key) => {
    if (activeButton === "promoter") {
      if (key === "male") {
        return "#006306";
      } else {
        return "#008908";
      }
    } else if (activeButton === "neutral") {
      if (key === "male") {
        return "#AE8800";
      } else {
        return "#FFB300";
      }
    } else if (activeButton === "detractor") {
      if (key === "male") {
        return "#910000";
      } else {
        return "#E94235";
      }
    }
  };

  const generateAgeData = () => {
    const maleData = Array.from({ length: 16 }, (_, index) => ({
      ageGroup: `${index * 10}-${(index + 1) * 10}`,
      male: Math.floor(Math.random() * 100),
      female: Math.floor(Math.random() * 100),
    }));

    // const femaleData = Array.from({ length: 16 }, (_, index) => ({
    //   ageGroup: `${index * 10}-${(index + 1) * 10}`,
    //   female: Math.floor(Math.random() * 100),
    // }));

    return [...maleData];
  };

  const ageData = generateAgeData();

  useEffect(() => {
    getIndicatorsAgeRange();
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getIndicatorsAgeRange();
    }
  }, [filtersDashboard]);

  return (
    <div className="age-group">
      <header className="age-group__header">
        <div className="cards-headers">
          <h4>Faixa etária</h4>
        </div>

        <div className="filter-buttons-container">
          <button
            className={`promoter-button ${
              activeButton === "promoter" ? "active" : ""
            }`}
            onClick={() => handleButtonClick("promoter")}
          >
            <span>
              <h5>Promotor</h5>
            </span>
          </button>
          <button
            className={`neutral-button ${
              activeButton === "neutral" ? "active" : ""
            }`}
            onClick={() => handleButtonClick("neutral")}
          >
            <span>
              <h5>Neutro</h5>
            </span>
          </button>
          <button
            className={`detractor-button ${
              activeButton === "detractor" ? "active" : ""
            }`}
            onClick={() => handleButtonClick("detractor")}
          >
            <span>
              <h5>Detrator</h5>
            </span>
          </button>
        </div>
      </header>

      <div className="age-group-graphs">
        {loading ? (
          <Paperplane width={"50%"} height={"100%"} />
        ) : dataGeneral.length ? (
          <div className="age-group-graphs__container">
            <div style={{ width: "50%", paddingRight: "10px" }}>
              <ResponsiveBar
                data={dataGeneral}
                keys={["male"]}
                indexBy="ageGroup"
                layout="horizontal"
                reverse={true}
                margin={{ top: 10, right: 10, bottom: 0, left: 60 }}
                padding={0.3}
                colors={[handleColors("male")]}
                // enableLabel={false}
                labelTextColor="#FFF"
                labelSkipHeight={12}
                borderRadius={4}
                axisLeft={{
                  tickSize: 0,
                  tickPadding: 5,
                  tickRotation: 0,
                  legendPosition: "middle",
                  legendOffset: -40,
                }}
                axisBottom={{
                  tickSize: 0,
                  tickPadding: 5,
                  tickRotation: 0,
                }}
                tooltip={({ id, value, color, indexValue }) => (
                  <div
                    style={{
                      padding: 5,
                      color: "#222222",
                      background: "#ffffff",
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.35)",
                    }}
                  >
                    <div
                      style={{ width: 14, height: 14, backgroundColor: color }}
                    ></div>
                    <div>
                      Masculino - {indexValue}: <strong>{value}</strong>
                    </div>
                  </div>
                )}
                // tooltip={({ id, value, color }) => (
                //   <div
                //     style={{
                //       padding: 12,
                //       color,
                //       background: "#222222",
                //     }}
                //   >
                //     <span>Look, I'm custom :)</span>
                //     <br />
                //     <strong>
                //       {id}: {value}
                //     </strong>
                //   </div>
                // )}
              />
            </div>
            <div style={{ width: "50%", paddingLeft: "10px" }}>
              <ResponsiveBar
                data={dataGeneral}
                keys={["female"]}
                indexBy="ageGroup"
                layout="horizontal"
                margin={{ top: 10, right: 60, bottom: 0, left: 10 }}
                padding={0.3}
                colors={[handleColors("female")]}
                // enableLabel={false}
                labelTextColor="#FFF"
                labelSkipHeight={12}
                borderRadius={4}
                axisLeft={null}
                axisBottom={{
                  tickSize: 0,
                  tickPadding: 5,
                  tickRotation: 0,
                }}
                tooltip={({ id, value, color, indexValue }) => (
                  <div
                    style={{
                      padding: 5,
                      color: "#222222",
                      background: "#ffffff",
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.35)",
                    }}
                  >
                    <div
                      style={{ width: 14, height: 14, backgroundColor: color }}
                    ></div>
                    <div>
                      Feminino - {indexValue}: <strong>{value}</strong>
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        ) : (
          <div className="card-table__area-empty">
            <EmptyState />
          </div>
        )}
      </div>

      <div className="age-group-indicators">
        {Object.keys(indicatorsMap).map((key) => {
          const { className, text, gender } = indicatorsMap[key];
          return (
            <span key={key} className={className}>
              <div
                className={
                  gender === "F"
                    ? `${className}__colorF`
                    : `${className}__color`
                }
              />
              <h6 className={`${className}__h6`}>{text}</h6>
            </span>
          );
        })}
      </div>
    </div>
  );
}
